import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActiveCartFacade, CreateCartEvent } from '@spartacus/cart/base/root';
import { AuthService, BASE_SITE_CONTEXT_ID, EventService, OccEndpointsService, SiteContextParamsService, StatePersistenceService, StorageSyncType, UserIdService } from '@spartacus/core';
import { BehaviorSubject, Observable, combineLatest, of } from 'rxjs';
import { switchMap, startWith, map, distinctUntilChanged, takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class KbCartService {
  private _cartData = new BehaviorSubject<any>(null);
  cartEntrydata$ = this._cartData.asObservable();
  cartEntries$: Observable<any>;
  saveCartMsg = new BehaviorSubject(null);
  userId: string;
  constructor(private ActiveCartService: ActiveCartFacade,
    private http: HttpClient,
    private occEndPointService: OccEndpointsService,
    protected authService: AuthService,
    protected statePersistenceService: StatePersistenceService,
    protected siteContextParamsService: SiteContextParamsService,
    protected eventService: EventService,
    protected userIdService: UserIdService
  ) {
    this.userIdService.getUserId().subscribe((uid) => (this.userId = uid));
  }

  getcurrentCartData() {
    this.cartEntries$ = this.ActiveCartService.getEntries();
    this._cartData.next(this.cartEntries$);
    return this.cartEntries$;
  }
  getQuantity(): Observable<number> {
    return this.activeCartRequired().pipe(
      switchMap((activeCartRequired) => {
        if (activeCartRequired) {
          return this.ActiveCartService.getActive().pipe(
            startWith({ totalUnitCount: 0 }),
            map((cart) => cart.totalUnitCount || 0)
          );
        } else {
          return of(0);
        }
      })
    );
  }
  updateDeliveyDate(cartId, updatedRdd, entryNbr, rdd) {
    return this.http.post(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartId}/updatedeliverydate?updateRequestedDeliveryDate=${updatedRdd}&entryNumber=${entryNbr}&requestedDeliveyDate=${rdd}`), {})
  }

  updateOrderType(cartId, orderType) {
    return this.http.post(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartId}/updateordertype?&orderType=${orderType}`), {})
  }

  bulkRemove(cartId, entryNumbers, isBulkRemove?: boolean) {
    return this.http.post(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartId}/bulkremove?&${entryNumbers}&isBulkRemove=${isBulkRemove}`), {})
  }

  getCartDetails(cartId) {
    return this.http.get(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartId}?fields=DEFAULT,potentialProductPromotions,appliedProductPromotions,potentialOrderPromotions,appliedOrderPromotions,entries(totalPrice(formattedValue),product(images(FULL),stock(FULL)),basePrice(formattedValue,value),updateable),totalPrice(formattedValue),totalItems,totalPriceWithTax(formattedValue),totalDiscounts(value,formattedValue),subTotal(formattedValue),totalUnitCount,deliveryItemsQuantity,deliveryCost(formattedValue),totalTax(formattedValue, value),pickupItemsQuantity,net,appliedVouchers,productDiscounts(formattedValue),user,saveTime,name,description`))
  }

  getSavedCartDetails(cartId) {
    return this.http.get(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartId}/getSavedCart`))
  }



  protected activeCartRequired(): Observable<boolean> {
    return combineLatest([
      this.hasActiveCartInStorage(),
      this.authService.isUserLoggedIn(),
      this.isCartCreated(),
    ]).pipe(
      map(
        ([hasCartInStorage, isUserLoggedIn, isCartCreated]) =>
          hasCartInStorage || isUserLoggedIn || isCartCreated
      ),
      distinctUntilChanged(),
      takeWhile((hasCart) => !hasCart, true)
    );
  }

  protected hasActiveCartInStorage(): Observable<boolean> {
    return this.getCartStateFromBrowserStorage().pipe(
      map((state) => Boolean(state?.active))
    );
  }

  protected isCartCreated(): Observable<boolean> {
    return this.eventService.get(CreateCartEvent).pipe(
      map((_) => true),
      startWith(false)
    );
  }

  protected getCartStateFromBrowserStorage(): Observable<
    { active: string } | undefined
  > {
    return this.siteContextParamsService.getValues([BASE_SITE_CONTEXT_ID]).pipe(
      map((context) => {
        return this.statePersistenceService.readStateFromStorage({
          key: 'cart',
          context: context,
          storageType: StorageSyncType.LOCAL_STORAGE,
        });
      })
    );
  }

  saveNewCart(payload, cartId) {
    return this.http.post(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartId}/kbsave?saveCartDescription=${payload.saveCartDescription}&saveCartName=${payload.saveCartName}`), {})
  }

  saveExistingCart(payload, cartId) {
    return this.http.post(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartId}/savetoexistingcart?cartId=${payload.cartId}&saveCartName=${payload.saveCartName}`), {})
  }
}
